import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Tag, Sparkles, Flame } from "lucide-react";
import { api, STORE_LABEL, priceFmt, dealTitle } from "../lib/api";

/**
 * Auto-scrolling marquee strip displaying the most recent deals.
 * Sits under the header for an "always-fresh" feel.
 */
export default function DealsMarquee() {
  const { data } = useQuery({
    queryKey: ["marquee-deals"],
    queryFn: () =>
      api
        .get("/deals", { params: { limit: 12, sort: "recent" } })
        .then((r) => r.data.items),
    staleTime: 30_000,
  });
  const items = data || [];
  if (items.length === 0) return null;

  // duplicate for seamless loop
  const loop = [...items, ...items];

  return (
    <div
      data-testid="deals-marquee"
      className="border-b border-[#1f2c4a] bg-gradient-to-r from-[#0d162d] via-[#131e3a] to-[#0d162d] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-4 py-2.5">
          <div className="shrink-0 inline-flex items-center gap-2 bg-[#FBD51C] text-black text-[10px] font-black uppercase tracking-[0.2em] px-2.5 py-1 rounded-md">
            <Flame size={11} /> Live
          </div>
          <div className="relative flex-1 overflow-hidden">
            <div
              className="flex gap-6 whitespace-nowrap"
              style={{
                animation: "marquee 60s linear infinite",
                width: "max-content",
              }}
            >
              {loop.map((d, i) => (
                <a
                  key={`${d.id}-${i}`}
                  href={`/offerta/${d.id}`}
                  className="inline-flex items-center gap-2 text-sm text-[#b6c1d6] hover:text-white transition-colors"
                >
                  <Tag size={12} className="text-[#FBD51C] shrink-0" />
                  <span className="font-bold text-white max-w-[28ch] truncate">
                    {dealTitle(d)}
                  </span>
                  {d.price_current ? (
                    <span className="font-mono-bdd text-[#FBD51C] text-xs">
                      {priceFmt(d.price_current)}
                    </span>
                  ) : null}
                  {d.discount_percent ? (
                    <span className="font-mono-bdd text-rose-400 text-xs">
                      -{d.discount_percent}%
                    </span>
                  ) : null}
                  <span className="text-[10px] uppercase tracking-wider text-[#6e7896]">
                    {STORE_LABEL[d.store]}
                  </span>
                  <span className="text-[#1f2c4a]">•</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
